import { render } from "./MaoChipIconText.vue?vue&type=template&id=d82f8ade&scoped=true"
import script from "./MaoChipIconText.vue?vue&type=script&lang=js"
export * from "./MaoChipIconText.vue?vue&type=script&lang=js"

import "./MaoChipIconText.vue?vue&type=style&index=0&id=d82f8ade&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d82f8ade"]])

export default __exports__